import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import WithdrawalHistory from './WithdrawalHistory';
import DepositHistory from './DepositHistory';
import { totalReciveDonate } from '../../../api';
import { useSelector } from 'react-redux';
import { RootState } from '../../../configuration';
import RequestUnlockDonate from '../../../components/request-unlock-donate/request-unlock-donate.component';
import { HandCoins, Lock } from 'lucide-react';
import Wallet from './Wallet';
import dayjs from 'dayjs';
import { EmptyComponent } from '../../../components/empty/empty-component';
import waitResponse from '../../../images/profile/wait.png';
import { PostDetailComponent } from '../../../components/post/post-detail.component';

export const TabDonate = () => {
  const [activeTabDonate, setActiveTabDonate] = useState('withdrawal-history');
  const [historyDonate, setHistoryDonate] = useState<any>();
  // Bài viết nguồn donate: mở dialog ngay tại trang (đóng thì ở lại đây, không out về trang chủ)
  const [viewPostId, setViewPostId] = useState<string | null>(null);
  // Doanh thu/lịch sử donate tính bằng Ca → hiển thị "... Ca" (thống nhất đơn vị "Ca" toàn app)
  const formatCa = (value: number) => `${Number(value).toLocaleString('vi-VN')} Ca`;
  const profile = useSelector(
    (state: RootState) => state.features.auth.profile
  );
  const [totalRecivesDonate, setTotalRecivesDonate] = useState('0');
  useEffect(() => {
    const fetchTotalDonate = async () => {
      try {
        const response = await totalReciveDonate();
        setHistoryDonate(response.histories);
        const totalCoins = response.totalAmount;
        setTotalRecivesDonate(formatCa(totalCoins));
      } catch (error) {
        console.error('Failed to fetch leaderboard:', error);
      }
    };
    fetchTotalDonate();
  }, [profile?.userId]);

  if (!profile) {
    return null;
  }
  if (profile.canReceiveDonation) {
    return (
      <div className="flex flex-col gap-3">
        <div className="flex w-full gap-3">
          <button
            className={`border border-[#0071A6]  font-semibold text-base w-[88px] h-10 flex items-center justify-center  dark:bg-slate-850 rounded-[100px] dark:text-white ${
              activeTabDonate === 'withdrawal-history'
                ? ' bg-[#0071A6] dark:bg-[#0071A6] text-white'
                : ' bg-white text-[#0071A6]'
            }`}
            onClick={() => setActiveTabDonate('withdrawal-history')}
          >
            Lịch sử
          </button>
          <button
            className={`border border-[#0071A6]  font-semibold text-base w-[88px] h-10 flex items-center justify-center  dark:bg-slate-850 rounded-[100px] dark:text-white ${
              activeTabDonate === 'donate'
                ? ' bg-[#0071A6] dark:bg-[#0071A6] text-white'
                : ' bg-white text-[#0071A6]'
            }`}
            onClick={() => setActiveTabDonate('donate')}
          >
            Tổng quan
          </button>
          <button
            className={`border border-[#0071A6]  font-semibold text-base w-[88px] h-10 flex items-center justify-center  dark:bg-slate-850 rounded-[100px] dark:text-white  ${
              activeTabDonate === 'wallet'
                ? ' bg-[#0071A6] dark:bg-[#0071A6] text-white'
                : ' bg-white text-[#0071A6]'
            }`}
            onClick={() => setActiveTabDonate('wallet')}
          >
            Ví
          </button>
        </div>

        {activeTabDonate === 'withdrawal-history' && <WithdrawalHistory />}
        {activeTabDonate === 'donate' && (
          <>
            <div className="relative flex flex-col min-w-0 break-words box dark:bg-slate-850 dark:shadow-dark-xl rounded-2xl bg-clip-border">
              <div className="w-full flex flex-col border border-[#DEE0E6] dark:border-slate-700 rounded-lg">
                <span className="text-[22px] leading-[27px] text-[#18191E]  font-semibold  p-3">
                  Doanh thu donate
                </span>
                <div className="flex flex-col gap-1 p-3 py-6 bg-[#F6F7F8]">
                  <p className="text-sm font-semibold text-[#62677D]">
                    Tổng doanh thu donate
                  </p>
                  <h5 className="mb-2 font-bold dark:text-white">
                    {totalRecivesDonate}
                  </h5>
                </div>
              </div>
            </div>
            <div className="relative flex flex-col border border-[#DEE0E6] dark:border-slate-700 rounded-xl  dark:bg-slate-850 dark:shadow-dark-xl">
              <span className="text-[22px] leading-[27px] text-[#18191E]  font-semibold  p-3 dark:text-white">
                Lịch sử donate
              </span>

              {historyDonate && historyDonate.length > 0 ? (
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="rounded-t-xl">
                    <tr>
                      <th className="px-6 py-3 bg-gray-50 dark:bg-slate-800 text-left text-xs font-medium text-gray-500 dark:text-slate-300 uppercase tracking-wider">
                        Tên
                      </th>
                      <th className="px-6 py-3 bg-gray-50 dark:bg-slate-800 text-left text-xs font-medium text-gray-500 dark:text-slate-300 uppercase tracking-wider">
                        Lời nhắn
                      </th>
                      <th className="px-6 py-3 bg-gray-50 dark:bg-slate-800 text-left text-xs font-medium text-gray-500 dark:text-slate-300 uppercase tracking-wider">
                        Nguồn
                      </th>
                      <th className="px-6 py-3 bg-gray-50 dark:bg-slate-800 text-left text-xs font-medium text-gray-500 dark:text-slate-300 uppercase tracking-wider">
                        Thời gian
                      </th>
                      <th className="px-6 py-3 bg-gray-50 dark:bg-slate-800 text-left text-xs font-medium text-gray-500 dark:text-slate-300 uppercase tracking-wider">
                        Số Ca
                      </th>
                    </tr>
                  </thead>
                  <tbody className=" divide-y divide-gray-200 dark:divide-slate-700">
                    {historyDonate.map((item: any, index: number) => (
                      <tr key={index}>
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                          {item.donater ? (
                            <Link
                              to={`/user/${item.donater}`}
                              className="text-blue-600 dark:text-blue-400 hover:underline"
                            >
                              {item.donater}
                            </Link>
                          ) : (
                            <span className="text-gray-900 dark:text-white">Ẩn danh</span>
                          )}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-slate-300 max-w-[300px] overflow-hidden overflow-ellipsis">
                          {item.message || '—'}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm">
                          {item.postId ? (
                            <button
                              type="button"
                              onClick={() => setViewPostId(item.postId)}
                              className="text-blue-600 dark:text-blue-400 hover:underline"
                            >
                              Bài viết
                            </button>
                          ) : (
                            <span className="text-gray-500 dark:text-slate-300">Trang cá nhân</span>
                          )}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-slate-300">
                          {dayjs(item.donatedAt).format('DD/MM/YYYY HH:mm:ss')}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-slate-300">
                          {formatCa(item.amount)}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <div className="bg-[#F6F7F8] py-3">
                  <EmptyComponent />
                </div>
              )}
            </div>
          </>
        )}
        {activeTabDonate === 'wallet' && <Wallet />}
        {viewPostId && (
          <PostDetailComponent
            postId={viewPostId}
            onClose={() => setViewPostId(null)}
          />
        )}
      </div>
    );
  }
  return (
    <div className="flex flex-col justify-center bg-[#DEE0E6] items-center h-fix box py-4">
      {profile.isCreateRequestReciveDonate ? (
        <div className="flex flex-col bg-[#DEE0E6] justify-center items-center">
          <img
            className="w-full max-w-[295px] aspect-[295/145]"
            src={waitResponse}
            alt="wait"
          />
          <p className="text-base font-medium text-[#15273F] mt-2 dark:text-white/80 p-5">
            Bạn đã gửi yêu cầu chờ phản hồi !
          </p>
        </div>
      ) : (
        <div className="flex justify-center flex-col gap-4 p-4">
          <img
            className="w-full max-w-[295px] aspect-[295/145]"
            src={waitResponse}
            alt="wait"
          />
          <p className="text-sm font-medium text-[#15273F] dark:text-white/80 p-5">
            Bạn chưa mở chức năng nhận donate
          </p>
          <RequestUnlockDonate />
        </div>
      )}
    </div>
  );
};
